import { Injectable } from "@angular/core";
import { HttpApiService } from "../../core/authentication/services/http-api.service";
import { userApi } from "../../core/model/constants/endpoints";
import { from, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class DashboardService {
    constructor(private httpApiService: HttpApiService) { }


    getPanelistPoints(): Observable<any> {
        const pointHistoryApi = this.httpApiService.get(`${userApi.getPanelistPoints}`);
        return from(pointHistoryApi); // Wrap Promise in Observable
    }
}